<template>
  光伏支架
</template>

<script>
export default {

}
</script>

<style>

</style>